import { Component, inject, output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService, Validators } from '@peca/commons';
import { AutocompleteItemSource, ModalComponent } from '@peca/design-system';
import { BehaviorSubject } from 'rxjs';
import { InboundInvoicesService } from '../../../services/inbound-invoices.service';
import { InboundInvoice } from '../../../models/fiscal/inbound-invoice.model';

@Component({
  selector: 'peca-purchase-order-modal-association-nf',
  templateUrl: './purchase-order-modal-association-nf.component.html',
  styleUrl: './purchase-order-modal-association-nf.component.scss',
  standalone: false,
})
export class PurchaseOrderModalAssociationNfComponent {
  @ViewChild('modal') modal!: ModalComponent;

  toast = inject(ToastService);
  service = inject(InboundInvoicesService);

  confirm = output<string>();

  invoices$ = new BehaviorSubject<AutocompleteItemSource>({});
  form = new FormGroup({
    invoice: new FormControl<InboundInvoice | null>(null, [Validators.required]),
  });

  get formValue() {
    return {
      invoice: this.form.get('invoice')?.value,
    };
  }

  open() {
    this.modal.open();
  }

  onClickConfirm() {
    const invoice = this.formValue.invoice;
    if (this.form.invalid || !invoice?.id) return;
    this.modal.close();
    this.confirm.emit(invoice?.id);
    this.form.reset();
  }

  onAutoCompleteInvoice(nfCode: string) {
    if (nfCode.length < 3) return;

    this.invoices$.next({ loading: true });
    this.service.suggestions(nfCode, false, false).subscribe({
      next: (data) => this.invoices$.next({ data }),
      error: () => this.invoices$.next({ failure: true }),
    });
  }
}
